module.exports = __webpack_public_path__ + "img/ring_0_0_null_0.7b9d76a2.png";